module.exports = __webpack_public_path__ + "img/home_6.ae1f8ce0.jpg";